import React from "react";

const Payment = () => {
  return (
    <div className="flex justify-center items-center min-h-screen">
      <h2 className="text-2xl font-bold text-gray-800">
        Payment System Coming Soon!
      </h2>
    </div>
  );
};

export default Payment;
